/**
 * Точка входа в ассистента (US-10 FR-1.1) — плавающая кнопка ✨ в правом
 * нижнем углу поверх текущего экрана.
 *
 * Вторая точка входа по постановке — «искорка» в строке поиска по
 * показателям; сам поиск в шапке сейчас закомментирован как заглушка до
 * появления API, поэтому здесь только кнопка. Когда поиск вернётся,
 * искорке хватит `openAssistant()` из AssistantContext.
 *
 * z-[1100] — как у выпадающих меню витрины: на главной кнопка лежит поверх
 * Leaflet, у которого свои слои до 1000 (`.leaflet-bottom` с контролом зума).
 * Сам контрол зума отодвинут вверх в index.css, чтобы кнопка его не накрыла.
 */
import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useAssistant } from './AssistantContext';

export const AssistantLauncher = () => {
  const { t } = useTranslation();
  const { open, openAssistant } = useAssistant();

  // Пока панель открыта, кнопка не нужна — она осталась бы поверх оверлея.
  if (open) return null;

  return (
    <button
      type="button"
      onClick={openAssistant}
      aria-label={t('assistant.open')}
      title={t('assistant.open')}
      data-testid="assistant-fab"
      className="fixed bottom-6 right-6 z-[1100] flex size-14 items-center justify-center rounded-full bg-brand-500 text-text-inverted shadow-pop transition-transform hover:scale-105"
    >
      <span
        className="absolute -inset-1.5 animate-ping-ring rounded-full border-2 border-brand-500"
        aria-hidden="true"
      />
      <Sparkles className="size-6" aria-hidden="true" />
    </button>
  );
};
